export const CART_ITEM_ADD = 'cart/item.add'

export const track = (type: string, detail: object) => {
  const event = new CustomEvent(type, { detail })
  document.dispatchEvent(event)
}
